module.exports = __webpack_public_path__ + "media/images/icons/country_flags/dz-0f0875827805c6719abb646001357855.svg";